var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "80%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card-actions",
            [
              _c(
                "v-card-text",
                [
                  _vm._v("Key: "),
                  _c(
                    "v-chip",
                    {
                      staticClass: "white--text",
                      attrs: { color: "blue", small: "" },
                    },
                    [_vm._v(_vm._s(this.keyName))]
                  ),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "grey" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "mt-n4" },
            [
              _c(
                "v-card",
                { attrs: { width: "100%", elevation: "0" } },
                [
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "ml-2",
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-actions",
                            { staticClass: "ma-0 pa-0" },
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "white--text",
                                  attrs: { color: "orange", small: "" },
                                },
                                [_vm._v("Old value")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-card",
                        {
                          style: _vm.borderLeft,
                          attrs: {
                            elevation: "0",
                            outlined: "",
                            height: "200px",
                            width: "100%",
                            ripple: false,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectPart(0)
                            },
                          },
                        },
                        [
                          _c(
                            "v-card-actions",
                            [
                              _c("v-card-text", { staticClass: "ma-1 pa-1" }, [
                                _vm._v(_vm._s(this.oldValue)),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card",
                {
                  staticClass: "mt-0",
                  attrs: { width: "100%", elevation: "0" },
                },
                [
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "ml-2",
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-actions",
                            { staticClass: "ma-0 pa-0" },
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "white--text",
                                  attrs: { color: "green", small: "" },
                                },
                                [_vm._v("New value")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-card",
                        {
                          style: _vm.borderRight,
                          attrs: {
                            elevation: "0",
                            outlined: "",
                            height: "200px",
                            width: "100%",
                            ripple: false,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectPart(1)
                            },
                          },
                        },
                        [
                          _c(
                            "v-card-actions",
                            [
                              _c("v-card-text", { staticClass: "ma-1 pa-1" }, [
                                _vm._v(_vm._s(this.newValue)),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 white--text",
                  attrs: { color: "red", elevation: "0" },
                  on: { click: _vm.onPressSkip },
                },
                [_vm._v("SKIP")]
              ),
              _c("v-spacer"),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { color: "primary", elevation: "0" },
                  on: { click: _vm.onPressNext },
                },
                [_vm._v("NEXT")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }